/**
 * ProseMirror focuses the editor after a delay, so we need to wait for that to complete before doing anything with focus.
 * Use this if focus command was called and you need to move cursor after that.
 *
 * Prefer this to other delaying methods like queueMicrotask in this case.
 *
 * @example
 * tiptap.chain().focus(position).run();
 * ...
 * afterDelayedFocus(() => {
 *   doc.cursor.moveToEnd();
 * });
 */
export function afterDelayedFocus(cb: () => void) {
  return requestAnimationFrame(cb);
}
